import moment from 'moment';

export const formatDate = (date) => {
    if (!date) return '-';
    return moment(date).utcOffset("+05:30").format('DD-MMM-YYYY');
};

export const formatDateTime = (date) => {
    if (!date) return '-';
    return moment(date).utcOffset("+05:30").format('DD-MMM-YYYY hh:mm A');
};
